module.exports = __webpack_public_path__ + "media/videos/showreel.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/videos/showreel.mp4
// module id = 154
// module chunks = 0